<p-fileUpload [customUpload]="true" (uploadHandler)="onFileUploading($event)" name="file[]"  auto="auto" 
  (onError)="onUploadError($event)" ngDefaultControl [accept]="accept" [chooseLabel]="uploadButtonLabel" [maxFileSize]="maxSize"
  [invalidFileSizeMessageSummary]="maxSizeMessage">
</p-fileUpload>

  